import { connect } from "react-redux";
import MistakeBookTestScreen from "./MistakeBookTestScreen";
import "./MistakeBookExamPage.css";
import usePreventUnload from "../../shared/hooks/usePreventUnload";
import LoaderPopUp from "../loader/loader";

const MistakeBookExamPage = ({ loader }) => {
  const alertMessage = "You cannot leave this page during the exam!";
  usePreventUnload(alertMessage);

  return (
    <div className="exam_page_wrapper">
      <MistakeBookTestScreen />
      {loader && <LoaderPopUp />}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
  };
};

export default connect(mapStateToProps)(MistakeBookExamPage);
